import * as React from 'react';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { Billboard, PageTitle } from '@/components/common';

const AboutPage: NextPage = () => {
  return <>
      <NextSeo title='About' />
      <PageTitle>About</PageTitle>
      <section>
        <Billboard heading='A femtech company for women, by women.' image='/images/billboard/femtech-company.jpg' kicker='Who We Are' variant='default' />
        <p className='max-w-3xl mx-auto my-8 md:my-12 px-6 md:px-12 text-xl leading-8'>
          Ours is the story of sisters, daughters, and mothers everywhere. Women who have struggled with hormone
          imbalances, mood swings, unhealthy weight, depression, painful periods, PCOS, endometriosis, and infertility.
          Women who&apos;ve decided enough is enough.
        </p>
        <p className='max-w-3xl mx-auto my-8 md:my-12 px-6 md:px-12 text-xl leading-8'>
          Enough of “it&apos;s all in your head,” or “that&apos;s just the way it is.” Enough of suffering silently in
          the passenger seat of our own bodies as we look to once trusted institutions that have sold themselves to the
          highest bidder. Enough with society&apos;s limiting beliefs that our bodies are an inconvenience and our
          nature needs suppressing.
        </p>
        <p className='max-w-3xl mx-auto my-8 md:my-12 px-6 md:px-12 text-xl leading-8'>
          Our story is one of love, courage, and perseverance. With love, we embrace our nature and our bodies, and care
          for them the way they deserve. With courage, we asked questions that were unpopular, challenged the status
          quo, and didn&apos;t wait for society&apos;s permission. And with perseverance, we created 28 to empower all
          women to experience healing, harmony, beauty, and strength. This path is inside all of us, and our cycles hold
          the key. A few years ago, we set out to unlock it and help women everywhere do the same.
        </p>
      </section>
      <section>
        <Billboard heading="Fitness tailored to your body's natural cycle." image='/images/billboard/tailored-fitness.jpg' kicker='What We Do' variant='default' />
        <p className='max-w-3xl mx-auto my-8 md:my-12 px-6 md:px-12 text-xl leading-8'>
          28 provides women with a hyper-personalized, first-of-its-kind, feminine fitness + holistic wellness
          experience, powered by custom technology and each user&apos;s natural cycle. We provide world-class,
          customized streaming workouts, nutrition profiles designed for hormone health, and science-based insights into
          yourself, your relationships, and your work, tailored to your current emotional state.
        </p>
      </section>
      <section>
        <Billboard heading='Empowering women to radically improve their health by embracing their nature.' image='/images/billboard/helping-women.jpg' kicker='Why we do it' variant='default' />
        <p className='max-w-3xl mx-auto my-8 md:my-12 px-6 md:px-12 text-xl leading-8'>
          We&apos;re on a mission to demystify and destigmatize menstrual health by enabling women to embrace their
          feminine nature, not fight it. Today, millions of women are saying goodbye to hormonal birth control and
          discovering their cycle, often for the first time. For years, many of us were in the dark about our own
          bodies, unaware of how our cycle truly works or how our hormones impact everything from our skin, weight,
          mental health, and menstruation. Some call this moment an awakening. Some call it a revolution. We like to
          think of it as a movement to lead ourselves and others toward happier, healthier lives. More than anything,
          it&apos;s a call to reclaim control of our bodies, in the most natural way possible. If your cycle is your
          compass, then 28 is your path to healthy hormones, self-discovery, and a beautiful, feminine physique.
        </p>
      </section>
    </>;
};

export default AboutPage;